import createValues from './createValues';
import plain from './structure/plain';

export default createValues(plain);


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/values.js
// module id = 1256
// module chunks = 4